export default __webpack_public_path__ + "static/media/paper.e9548ae1.png";